import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { PrintersComponent } from './printers.component';

export const PRINTERS_ROUTES: Routes = [
  {
    path: 'printers', component: PrintersComponent, canActivate: [AuthGuard], children: []
  }
];
